import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import Login from "../../Authentication/Login";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import MarketingTabs from "../AllTabs/MarketingTabs";

const initialFieldValues = {
  packageDateId: "00000000-0000-0000-0000-000000000000",
  companyId: "00000000-0000-0000-0000-000000000000",
  userId: "00000000-0000-0000-0000-000000000000",
  startDate: "",
  endDate: "",
};

const PackageDate = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };
  const handleAddShow = () => {
    setRecordForEdit(null);
    setValues(initialFieldValues);
    setAddShow(true);
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  const GetData = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETPACKAGEDATEBYCOMPANYID}/${user?.cid}`,
      pageSize,
      pageNumber
    );
    console.log(res);
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };
  const GetLastPageData = () => {
    GetData(totalPages);
  };
  const GetFirstPageData = () => {
    GetData("1");
  };
  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };
  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGEDATE, itemToDelete);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
      }
      handleCloseDeleteModal();
    }
  };
  const validate = () => {
    let temp = {};
    temp.startDate = values.startDate !== "";
    temp.endDate = values.endDate !== "";
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        packageDateId: values.packageDateId,
        startDate: values.startDate,
        endDate: values.endDate,
        companyId: user?.cid,
        userId: user?.id,
      };
      console.log(formData);
      try {
        const isNew =
          formData.packageDateId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGEDATE, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGEDATE, formData);
        }
        await GetData(pageNumber);
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldsToUppercase = [" "];
    setValues({
      ...values,
      [name]: fieldsToUppercase.includes(name) ? value.toUpperCase() : value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    if (!loading && !user) {
      navigate("/");
    }
  }, [user, loading, navigate]);
  useEffect(() => {
    if (user) {
      GetData(pageNumber);
    }
  }, [user, pageNumber]);

  if (loading) {
    return <p>Loading...</p>;
  }
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            {/* ... (rest of your table JSX is fine) ... */}
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <MarketingTabs pageName="PACKAGEDATES" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                          Package Dates
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 &&
                          lists.map((v, index) => (
                            <tr key={v.packageDateId}>
                              <td>{index + 1}</td>
                              <td>
                                {moment(v.startDate).format("DD-MMM-YYYY")}
                              </td>

                              <td>{moment(v.endDate).format("DD-MMM-YYYY")}</td>

                              <td>
                                <ul className="list-inline hstack gap-2 mb-0">
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Edit"
                                  >
                                    <Link
                                      className="edit-item-btn"
                                      to="#"
                                      onClick={(e) => showEditDetails(v)}
                                    >
                                      <i className="ri-pencil-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    title="Delete"
                                  >
                                    <Link
                                      className="remove-item-btn"
                                      to="#"
                                      onClick={(e) =>
                                        handleOpenDeleteModal(v.packageDateId)
                                      }
                                    >
                                      <i className="ri-delete-bin-fill align-bottom text-muted" />
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item " +
                          (data.previousPage === null ? "disabled" : "")
                        }
                        onClick={() => data.previousPage && GetFirstPageData()}
                      >
                        <Link className="page-link" to="#">
                          Previous
                        </Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item " +
                          (data.nextPage === null ? "disabled" : "")
                        }
                        onClick={() => data.nextPage && GetLastPageData()}
                      >
                        <Link className="page-link" to="#">
                          Next
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {values.packageDateId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Package Dates
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="row">
                <div className="form-group">
                  <label>Start Date:</label>
                  <input
                    name="startDate"
                    type="date"
                    className="form-control"
                    value={values.startDate}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>End Date:</label>
                  <input
                    name="endDate"
                    type="date"
                    className="form-control"
                    value={values.endDate}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <Modal.Footer>
                <div className="hstack gap-2 justify-content-end">
                  {btnLoading === false ? (
                    <button type="submit" className="btn btn-primary">
                      {values.packageDateId ===
                      "00000000-0000-0000-0000-000000000000"
                        ? "Submit"
                        : "Update"}
                    </button>
                  ) : (
                    <button type="button" className="btn btn-primary" disabled>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Please wait...
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={resetForm}
                  >
                    Cancel
                  </button>
                </div>
              </Modal.Footer>
            </form>
          </Modal.Body>
        </Modal>
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </div>
  );
};

export default PackageDate;
